var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { BigNumber } from "ethers";
import { useGlobalState } from "../store/store";
import { getAssets } from "../constants/constants";
import useV2Vault from "./useV2Vault";
import { impersonateAddress } from "../utils/development";
import { isETHVault } from "../utils/vault";
import { getERC20Token } from "./useERC20Token";
var useV2VaultData = function (vault, _a) {
    var _b = _a === void 0 ? { poll: false, pollingFrequency: 5000 } : _a, poll = _b.poll, _c = _b.pollingFrequency, pollingFrequency = _c === void 0 ? 5000 : _c;
    var _d = useWeb3React(), active = _d.active, web3Account = _d.account, library = _d.library;
    var contract = useV2Vault(vault);
    var account = impersonateAddress ? impersonateAddress : web3Account;
    var _e = useState(false), loading = _e[0], setLoading = _e[1];
    var _f = useGlobalState("v2VaultData"), response = _f[0], setResponse = _f[1];
    var doMulticall = useCallback(function (isInterval) {
        if (isInterval === void 0) { isInterval = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            var unconnectedPromises, promises, _a, totalBalance, cap, pricePerShare, vaultState, depositReceipts, accountVaultBalance, userAssetBalance, withdrawals;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!contract) {
                            return [2 /*return*/];
                        }
                        if (!isInterval) {
                            setLoading(true);
                        }
                        unconnectedPromises = [
                            contract.totalBalance(),
                            contract.cap(),
                            contract.pricePerShare(),
                            contract.vaultState(),
                        ];
                        promises = unconnectedPromises.concat(active
                            ? [
                                contract.depositReceipts(account),
                                contract.accountVaultBalance(account),
                                isETHVault(vault)
                                    ? library.getBalance(account)
                                    : getERC20Token(library, getAssets(vault).toLowerCase()).balanceOf(account),
                                contract.withdrawals(account),
                            ]
                            : [
                                // Default value when not connected
                                Promise.resolve({ amount: BigNumber.from(0) }),
                                Promise.resolve(BigNumber.from(0)),
                                Promise.resolve(BigNumber.from(0)),
                                Promise.resolve({ round: 1, share: BigNumber.from(0) }),
                            ]);
                        return [4 /*yield*/, Promise.all(
                            // Default to 0 when error
                            promises.map(function (p) { return p.catch(function (e) { return BigNumber.from(0); }); }))];
                    case 1:
                        _a = _b.sent(), totalBalance = _a[0], cap = _a[1], pricePerShare = _a[2], vaultState = _a[3], depositReceipts = _a[4], accountVaultBalance = _a[5], userAssetBalance = _a[6], withdrawals = _a[7];
                        setResponse(function (prevResponse) {
                            var _a;
                            return (__assign(__assign({}, prevResponse), (_a = {}, _a[vault] = __assign(__assign({}, prevResponse[vault]), { totalBalance: totalBalance, cap: cap, pricePerShare: pricePerShare, round: vaultState.round, lockedBalanceInAsset: accountVaultBalance, depositBalanceInAsset: depositReceipts
                                    .amount, userAssetBalance: userAssetBalance, withdrawals: withdrawals }), _a)));
                        });
                        if (!isInterval) {
                            setLoading(false);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }, [account, active, contract, library, setResponse, vault]);
    useEffect(function () {
        var pollInterval = undefined;
        if (poll) {
            doMulticall(false);
            pollInterval = setInterval(doMulticall, pollingFrequency);
        }
        else {
            doMulticall(false);
        }
        return function () {
            if (pollInterval) {
                clearInterval(pollInterval);
            }
        };
    }, [poll, pollingFrequency, doMulticall]);
    return { data: response[vault], loading: loading };
};
export default useV2VaultData;
//# sourceMappingURL=useV2VaultData.js.map